import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CreditCard } from "lucide-react";

export const Route = createFileRoute("/_authenticated/_account/billing")({
  head: () => ({
    meta: [
      { title: "Billing — CoderLity" },
      { name: "description", content: "Manage your subscription and invoices." },
    ],
  }),
  component: BillingPage,
});

function BillingPage() {
  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-start justify-between gap-4">
            <div>
              <CardTitle>Current plan</CardTitle>
              <CardDescription>You're on the free plan.</CardDescription>
            </div>
            <Badge variant="secondary">Free</Badge>
          </div>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-3">
          <Button>Upgrade plan</Button>
          <Button variant="outline">Compare plans</Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Payment method</CardTitle>
          <CardDescription>No card on file yet.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button variant="outline" className="gap-2">
            <CreditCard className="h-4 w-4" /> Add payment method
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Invoices</CardTitle>
          <CardDescription>Your past invoices will appear here.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No invoices yet.</p>
        </CardContent>
      </Card>
    </>
  );
}
